/**
 * 任务模块 taskType / cycleType 与检查内容 contentType / applyCycle 共用码值（与后端约定一致）
 */

/** 任务类型下拉选项 */
export const TASK_TYPE_OPTIONS = [
  { value: 'xc', label: '巡查' },
  { value: 'wb', label: '维保' },
  { value: 'cs', label: '测试' }
];

/** 周期类型下拉选项：日常 → … → 专项 */
export const CYCLE_TYPE_OPTIONS = [
  { value: 'day', label: '日常' },
  { value: 'month', label: '月度' },
  { value: 'quarter', label: '季度' },
  { value: 'half_year', label: '半年' },
  { value: 'year', label: '年度' },
  { value: 'yearly_daily', label: '年度日查' },
  { value: 'special', label: '专项' }
];

/** 将下拉选项转换为 label 映射 */
function optionsToLabelMap (options) {
  return options.reduce((acc, { value, label }) => {
    acc[value] = label;
    return acc;
  }, {});
}

/** 任务类型 label 映射 */
export const TASK_TYPE_LABEL_MAP = optionsToLabelMap(TASK_TYPE_OPTIONS);
/** 周期类型 label 映射 */
export const CYCLE_TYPE_LABEL_MAP = optionsToLabelMap(CYCLE_TYPE_OPTIONS);

/** 获取任务类型 label */
export function getTaskTypeLabel (value) {
  if (value === null || value === undefined || value === '') return '';
  return TASK_TYPE_LABEL_MAP[value] || String(value);
}

/** 获取周期类型 label */
export function getCycleTypeLabel (value) {
  if (value === null || value === undefined || value === '') return '';
  return CYCLE_TYPE_LABEL_MAP[value] || String(value);
}

/** 日常、专项：不按任务年份约束 */
export const CYCLE_NO_TASK_YEAR = ['day', 'special'];

/** 年度、年度日查：支持「按月分解」 */
export const CYCLE_YEAR_SPLIT_MONTHLY = ['year', 'yearly_daily'];

/** 是否不按任务年份约束 */
export function isCycleWithoutTaskYear (cycleType) {
  return CYCLE_NO_TASK_YEAR.includes(cycleType);
}

/** 是否支持按月分解 */
export function isYearSplitMonthlyCycle (cycleType) {
  return CYCLE_YEAR_SPLIT_MONTHLY.includes(cycleType);
}

export const DEFAULT_TASK_TYPE = 'xc';
export const DEFAULT_CYCLE_TYPE = 'month';

/** 任务类型 el-tag type */
export const TASK_TYPE_TAG_MAP = {
  xc: '',
  wb: 'success',
  cs: 'warning'
};

/** 周期类型 el-tag type */
export const CYCLE_TYPE_TAG_MAP = {
  day: 'danger',
  month: 'warning',
  quarter: 'warning',
  half_year: '',
  year: '',
  yearly_daily: '',
  special: 'danger'
};

/** 获取任务类型 el-tag type */
export function getTaskTypeTag (type) {
  return type != null && Object.prototype.hasOwnProperty.call(TASK_TYPE_TAG_MAP, type)
    ? TASK_TYPE_TAG_MAP[type]
    : '';
}

/** 获取周期类型 el-tag type */
export function getCycleTypeTag (type) {
  return type != null && Object.prototype.hasOwnProperty.call(CYCLE_TYPE_TAG_MAP, type)
    ? CYCLE_TYPE_TAG_MAP[type]
    : 'info';
}
